import { render } from "./CrmDealKanbanDealDataModalReportModalPatientNotesComponent.vue?vue&type=template&id=95c3dae0"
import script from "./CrmDealKanbanDealDataModalReportModalPatientNotesComponent.vue?vue&type=script&lang=js"
export * from "./CrmDealKanbanDealDataModalReportModalPatientNotesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__